const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';
const TOKEN_KEY = 'whitelabel_admin_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

async function request(path, options = {}) {
  const headers = { ...(options.headers || {}) };
  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const response = await fetch(`${BACKEND_URL}${path}`, { ...options, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.error || 'Errore di rete');
    error.status = response.status;
    throw error;
  }
  return data;
}

export const adminApi = {
  login: (email, password) =>
    request('/admin/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),
  me: () => request('/admin/me'),
  getSettings: () => request('/admin/settings'),
  saveSettings: (payload) =>
    request('/admin/settings', { method: 'PUT', body: JSON.stringify(payload) }),
  getPrompt: () => request('/admin/prompt'),
  savePrompt: (payload) =>
    request('/admin/prompt', { method: 'PUT', body: JSON.stringify(payload) }),
  cleanPromptFormat: () => request('/admin/prompt/clean-format', { method: 'POST' }),
  getAppointments: () => request('/admin/appointments'),
  saveAppointments: (payload) =>
    request('/admin/appointments', { method: 'PUT', body: JSON.stringify(payload) }),
  getWhatsAppStatus: (refreshQr = false) =>
    request(`/admin/whatsapp/status${refreshQr ? '?qr=1' : ''}`),
  connectWhatsApp: () => request('/admin/whatsapp/connect', { method: 'POST' }),
  logoutWhatsApp: () => request('/admin/whatsapp/logout', { method: 'POST' }),
  getGoogleAuthUrl: () => request('/admin/google/auth-url'),
  getGoogleCalendars: () => request('/admin/google/calendars'),
  getProducts: () => request('/admin/products'),
  createProduct: (payload) =>
    request('/admin/products', { method: 'POST', body: JSON.stringify(payload) }),
  updateProduct: (id, payload) =>
    request(`/admin/products/${id}`, { method: 'PUT', body: JSON.stringify(payload) }),
  deleteProduct: (id) => request(`/admin/products/${id}`, { method: 'DELETE' }),
  factoryReset: () =>
    request('/admin/factory-reset', {
      method: 'POST',
      body: JSON.stringify({ confirm: 'AZZERA' }),
    }),
  upload: async (file) => {
    const form = new FormData();
    form.append('file', file);
    return request('/admin/upload', { method: 'POST', body: form });
  },
};
